import './modules/nav-active.js'
import './modules/swiper-sorvetes.js'
import './modules/swiper-novidades.js'
import './modules/aos.js'
import './modules/nav-scroll.js'
import { Fancybox } from '@fancyapps/ui'

import '@fancyapps/ui/dist/fancybox.css'

Fancybox.bind('[data-fancybox]', {
  // Your options go here
})

const toast = document.querySelector('.toast-alert .alert')
const toastCloseBtn = document.querySelector('.toast-alert .alert .close')

toastCloseBtn.addEventListener('click', () => {
    toast.style.display = 'none'
})
